import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function ArrowToBottomMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M13 13.172l4-4 1.414 1.414L12 17l-6.414-6.414L7 9.172l4 4V3h2v10.172zM5 19h14v2H5v-2z"  /></Svg>;
}
export default ArrowToBottomMedium;